"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var initialState = [];

function NotificationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  var newState = _lodash["default"].cloneDeep(state); // eslint-disable-line prefer-const


  switch (action.type) {
    case _constants.NOTIFICATION_SHOW:
      {
        newState.push({
          id: action.id,
          message: action.message,
          messageType: action.messageType
        });
        return newState;
      }

    case _constants.NOTIFICATION_HIDE:
      {
        newState.forEach(function (notification, index) {
          if (notification.id === action.id) {
            return newState.splice(index, 1);
          }
        });
        return newState;
      }

    case _constants.ALL_NOTIFICATIONS_HIDE:
      {
        return initialState;
      }

    default:
      {
        return newState;
      }
  }
}

var _default = NotificationsReducer;
exports["default"] = _default;